import createBaseLayers from "../../utils/createBaseLayers";
import createRoutingControl from "../../utils/createRoutingControl";
import LayerService from "../../utils/LayerService";
import { setMaplibreLayer } from "../../utils/maplibreStyle";

import type { Layer } from "ol/layer";

import type { Mot } from "../../utils/constants";

export const MapActionType = {
  SetBaseLayer: "SET_BASE_LAYER",
  SetBaseLayers: "SET_BASE_LAYERS",
  SetCenter: "SET_CENTER",
  SetExtent: "SET_EXTENT",
  SetLayers: "SET_LAYERS",
  SetLayerService: "SET_LAYER_SERVICE",
  SetMaxExtent: "SET_MAX_EXTENT",
  SetResolution: "SET_RESOLUTION",
  SetRotation: "SET_ROTATION",
  SetRoutingControl: "SET_ROUTING_CONTROL",
  SetSnappingType: "SET_SNAPPING_TYPE",
  SetStyleLayers: "SET_STYLE_LAYERS",
  SetZoom: "SET_ZOOM",
} as const;

export type MapActionType = (typeof MapActionType)[keyof typeof MapActionType];

export const SET_CENTER = MapActionType.SetCenter;
export const SET_LAYER_SERVICE = MapActionType.SetLayerService;
export const SET_RESOLUTION = MapActionType.SetResolution;
export const SET_ZOOM = MapActionType.SetZoom;
export const SET_STYLE_LAYERS = MapActionType.SetStyleLayers;
export const SET_EXTENT = MapActionType.SetExtent;
export const SET_ROTATION = MapActionType.SetRotation;
export const SET_BASE_LAYER = MapActionType.SetBaseLayer;
export const SET_SNAPPING_TYPE = MapActionType.SetSnappingType;
export const SET_BASE_LAYERS = MapActionType.SetBaseLayers;
export const SET_LAYERS = MapActionType.SetLayers;
export const SET_MAX_EXTENT = MapActionType.SetMaxExtent;
export const SET_ROUTING_CONTROL = MapActionType.SetRoutingControl;

export const setBaseLayer = (data: Layer) => {
  return {
    data,
    type: SET_BASE_LAYER,
  };
};

export const setLayerService = (data: LayerService) => {
  return {
    data,
    type: SET_LAYER_SERVICE,
  };
};

export const setStyleLayers = (data) => {
  return { data, type: SET_STYLE_LAYERS };
};

export const setCenter = (data: number[]) => {
  return { data, type: SET_CENTER };
};

export const setResolution = (data) => {
  return { data, type: SET_RESOLUTION };
};

export const setZoom = (data) => {
  return { data, type: SET_ZOOM };
};

export const setExtent = (data) => {
  return { data, type: SET_EXTENT };
};

export const setMaxExtent = (data) => {
  return { data, type: SET_MAX_EXTENT };
};

export const setRotation = (data) => {
  return { data, type: SET_ROTATION };
};

export const setBaseLayers = (data) => {
  return { data, type: SET_BASE_LAYERS };
};

export const setLayers = () => {
  return (dispatch, getState) => {
    const {
      app: { config, tilesKey, tilesUrl },
      map: { baseLayer, defaultBaseLayers, layers },
    } = getState();
    const newBaseLayers = createBaseLayers(
      [...(config.baseLayers || defaultBaseLayers)],
      { tilesKey, tilesUrl },
    );
    const otherLayers = layers.filter((layer) => {
      return !layer.get("isBaseLayer");
    });
    // Apply the current base layer to all the style layers.
    otherLayers.forEach((styleLayer) => {
      const baselayerr =
        newBaseLayers.find((bl) => {
          // @ts-expect-error - backward compatibility prop
          return bl.key === baseLayer.key;
        }) || newBaseLayers[0];
      setMaplibreLayer(styleLayer, baselayerr);
    });
    return dispatch({
      data: [...newBaseLayers, ...otherLayers],
      type: SET_LAYERS,
    });
  };
};

export const setSnappingType = (data) => {
  return {
    data,
    type: SET_SNAPPING_TYPE,
  };
};

export const setRoutingControl = (mot?: Mot) => {
  return (dispatch, getState) => {
    const routingControl = createRoutingControl(getState(), mot);
    return dispatch({
      data: routingControl,
      type: SET_ROUTING_CONTROL,
    });
  };
};
